import { render, staticRenderFns } from "./ComplementariesDiagnosis.vue?vue&type=template&id=06c6958e&"
import script from "./ComplementariesDiagnosis.vue?vue&type=script&lang=js&"
export * from "./ComplementariesDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./ComplementariesDiagnosis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports